import { motion } from "framer-motion"
import { useLanguage } from "../context/LanguageContext"
import { Link } from "react-router-dom"
import linkedinIcon from "../assets/icons/linkedin.svg"
import facebookIcon from "../assets/icons/facebook.svg"
import instagramIcon from "../assets/icons/instagram.svg"
import egIcon from "../assets/icons/eg-flag.svg"
import usIcon from "../assets/icons/use-flag.svg"
import saIcon from "../assets/icons/sa-flag.svg"
import { fadeDown, staggerContainer } from "../lib/motion"

const KSA_SITE_URL = "https://ksa.nowpay.com/"

export function Header() {
  const { lang, setLang, translation: t } = useLanguage()

  return (
    <motion.header
      className="md:flex md:justify-between md:items-center w-full pt-5 sm:py-5 px-6 md:px-12 lg:px-20 xl:px-[5.625rem]"
      variants={fadeDown}
      initial="hidden"
      animate="show"
    >
      <motion.div variants={fadeDown} className="hidden md:flex items-center h-full">
        <Link
          to={KSA_SITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="hover-scale"
          key={lang}
        >
          <div className="flex items-center justify-center gap-1 md:gap-2">
            <span className="md:text-lg text-sm">
              <img src={saIcon} alt="SA" className="w-4 h-3" aria-hidden />
            </span>
            <span className={`text-base font-normal text-primary ${lang === "ar" ? "font-arabic" : ""}`}>
              {t.visitSaudiSite}
            </span>             
          </div>
        </Link>
      </motion.div>
      <div>
        <motion.div
          className="flex items-center justify-between md:justify-end md:gap-[1.125rem] h-[1.875rem]"
          variants={staggerContainer(0.08, 0.05)}
          initial="hidden"
          animate="show"
          >
          {/* Hotline */}
          <motion.div className="text-primary" variants={fadeDown}>
            <span className="text-base">
              <span className="font-bold">{t.hotline} </span>
              <span className="font-normal inline-block" dir="ltr">
                {t.phoneNumber}
              </span>
            </span>
          </motion.div>

          <motion.div className="w-px h-4 bg-separatorsColor self-center" variants={fadeDown} />
          {/* Social Icons */}  
          <motion.div variants={fadeDown}>
            <Link
              to="https://www.linkedin.com/company/nowpay/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-6 h-6 bg-white rounded flex items-center justify-center hover:bg-gray-100 transition-colors hover-scale"
              aria-label="LinkedIn"
            >
              <img src={linkedinIcon} alt="LinkedIn" />
            </Link>
          </motion.div>
          <motion.div variants={fadeDown}>
            <Link
              to="https://www.instagram.com/nowpayapp/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-6 h-6 bg-white rounded flex items-center justify-center hover:bg-gray-100 transition-colors hover-scale"
              aria-label="Instagram"
            >
              <img src={instagramIcon} alt="Instagram" />
            </Link>
          </motion.div>
          <motion.div variants={fadeDown}>
            <Link
              to="https://www.facebook.com/NowPayDotCash"
              target="_blank"
              rel="noopener noreferrer"
              className="w-6 h-6 bg-white rounded flex items-center justify-center hover:bg-gray-100 transition-colors hover-scale"
              aria-label="Facebook"
            >
              <img src={facebookIcon} alt="Facebook" />
            </Link>
          </motion.div>

          <motion.div className="w-px h-4 bg-separatorsColor self-center" variants={fadeDown} />
          {/* Language Switcher */}
          <motion.div variants={fadeDown} className="h-full flex items-center">
            <button
              onClick={() => setLang(lang === "en" ? "ar" : "en")}
              className="hover-scale"
            >
              <div className="flex items-center justify-center gap-1 md:gap-2">
                <span className="md:text-lg text-sm">
                  {lang === "en" ?
                    <img src={egIcon} alt="AR" className="w-4 h-3" /> : <img src={usIcon} alt="ENG" className="w-4 h-3" />}
                </span>
                <span className={`hidden md:block text-base font-normal text-primary ${lang === "en" ? "font-arabic" : ""}`}>
                  {lang === "en" ? "العربية" : "English"}
                </span>             
              </div>
            </button>
          </motion.div>
        </motion.div>
      </div>
    </motion.header>
  )
}